import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InitialState } from './types'
import { saveMaterial } from './api'
import strings from '../../locale/en'

const initialState: InitialState = {
  type: '',
  sequenceNumber: '',
  materialTitle: '',
  text: '',
  image: null,
  video: {
    url: '',
    chat: ''
  },
  synposis: null,
  error: '',
  isLoading: false
}

export const addMaterialSlice = createSlice({
  name: 'addMaterialSlice',
  initialState,
  reducers: {
    setType: (state, action: PayloadAction<string>) => {
      state.type = action?.payload
    },
    setSequenceNumber: (state, action: PayloadAction<string>) => {
      state.sequenceNumber = action?.payload
    },
    setMaterialTitle: (state, action: PayloadAction<string>) => {
      state.materialTitle = action?.payload
    },
    setText: (state, action: PayloadAction<string>) => {
      state.text = action?.payload
    },
    setImage: (state, action: PayloadAction<any>) => {
      state.image = action?.payload
    },
    setSnyposis: (state, action: PayloadAction<any>) => {
      state.synposis = action?.payload
    },
    setVideoUrl: (state, action: PayloadAction<string>) => {
      state.video.url = action?.payload
    },
    setVideoChat: (state, action: PayloadAction<string>) => {
      state.video.chat = action?.payload
    },
    resetMaterialState: () => {
      return initialState
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action?.payload
    }
  },
  extraReducers: {
    [saveMaterial.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [saveMaterial.fulfilled.toString()]: (
      state,
      action: PayloadAction<string>
    ) => {
      state.error = action?.payload
      state.isLoading = false
    },
    [saveMaterial.rejected.toString()]: (state) => {
      state.error = strings?.error.addMaterialFailed
      state.isLoading = false
    }
  }
})

export default addMaterialSlice.reducer
